import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import isConsumer from "owa-session-store/lib/utils/isConsumer";
import { isServiceRequestSupportedForMailbox } from "owa-service/lib/utils/isServiceRequestSupportedForMailbox";
import { getApp } from "owa-config";
import { isPresenceLicenseEnabled } from "./isPresenceLicenseEnabled";

const isPresenceSupported = (mailboxInfo: MailboxInfo): boolean => {
    return ((isGlobalFeatureEnabled("mon-presence") || isPlacesApp()) &&
        !isConsumer(undefined, mailboxInfo) &&
        isServiceRequestSupportedForMailbox(mailboxInfo) &&
        isPresenceLicenseEnabled(mailboxInfo));
};

function isPlacesApp() {
    return getApp() === "Places";
}

export default isPresenceSupported;
